<br>
  <div class="container">
    @if (advertiser) {
      <div>
        <a href="{{advertiser.affiliateUrl}}" target="_blank" rel="noopener noreferrer"> @if (advertiser) {
          <img [alt]="pictureUrl" class="product-img"
            [src]="advertiser.pictureUrl || advertiser.storedPictureUrl" [appImgFallback]="advertiser.storedPictureUrl">
        } </a>
        <span  class="output-title-advertiser">{{ 'deals.advertiserTitle' | t }} <a href="{{advertiser.affiliateUrl}}" target="_blank" rel="noopener noreferrer">{{advertiser.advertiserName}}</a></span>
      </div>
    }
  </div>
  <br>
    <app-dashboard></app-dashboard>
